import React from 'react'

export const buttonStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#092B00',
  padding: '20px 16px',
  borderRadius: '6px',
  backgroundColor: '#95DE64',
  boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.04)',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '24px',
  marginTop: '12px'
}

export const passwordStrengthTransitionStyle: React.CSSProperties = {
  transition: 'all 0.3s ease-in-out',
  opacity: 1,
  transform: 'translateY(0)',
  maxHeight: '300px',
  overflow: 'hidden',
  marginBottom: '16px'
}

export const passwordStrengthHiddenStyle: React.CSSProperties = {
  transition: 'all 0.3s ease-in-out',
  opacity: 0,
  transform: 'translateY(-10px)',
  maxHeight: '0px',
  overflow: 'hidden',
  pointerEvents: 'none' as 'none',
  marginBottom: '0px'
}
